import React from 'react';
import { Badge, IconName, StatusValues } from '@usealloy/component-library';

type Props = {
  fraudSignalScore: number | null;
};

export const FraudSignalScoreBadge = ({ fraudSignalScore }: Props) => {
  if (fraudSignalScore == null) {
    return <>-</>;
  }

  const FraudSignalScoreThresholds = {
    HighRisk: 0.8,
    LowRisk: 0.25,
  } as const;

  let score = fraudSignalScore;
  if (fraudSignalScore >= 0.99) {
    score = 0.99;
  } else if (fraudSignalScore <= 0.01) {
    score = 0.01;
  }

  // Use fraudSignalScore to determine status/color when no color prop provided
  let icon = IconName.GaugeMid;
  let status = StatusValues.warning;
  if (score >= FraudSignalScoreThresholds.HighRisk) {
    status = StatusValues.danger;
    icon = IconName.GaugeHigh;
  } else if (score < FraudSignalScoreThresholds.LowRisk) {
    status = StatusValues.success;
    icon = IconName.GaugeLow;
  }

  return (
    <Badge
      status={status}
      icon={icon}
      size="large"
    >
      {Number(score).toFixed(2)}
    </Badge>
  );
};
